var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global-messages"},_vm._l((_vm.globalMessages),function(message,index){return _c('Snackbar',{key:index,attrs:{"data":message,"index":index,"isVisible":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }